import { fromJS } from 'immutable';
import * as constants from '../messaging-constants';
import R from 'ramda';

const initialDialogState = fromJS({
  open: false,
  files: [],
  msg: {},
  companyNameValue: '',
  newPartner: {},
  selectedPartner: {},
  startDateValue: '',
  endDateValue: '',
  creatingContract: false,
  createdContract: {},
  updatedContract: {},
  matchedRequestsByEmails: [],
  matchedRequestsByInput: [],
  allEmailsFromBody: [],
  searchingRequests: false,
  showRequests: false,
  partners: [],
});

export default (state = initialDialogState, { type, payload }) => {
  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_ACTION_DIALOG':
      if (R.has('open', payload) && !payload.open) {
        return state.merge(fromJS({
          open: false,
          files: [],
          msg: {},
          companyNameValue: '',
          creatingContract: false,
          createdContract: {},
          updatedContract: {},
          matchedRequestsByEmails: [],
          showRequests: false,
        }));
      }
      return state.merge(fromJS(payload));
    case 'GOT_MATCHED_REQUESTS_FOR_ADD_FILE_TO_CONTRACT':
      return state.merge(fromJS({
        matchedRequestsByEmails: payload.searchByInput ? state.get('matchedRequestsByEmails') : payload.requests,
        matchedRequestsByInput: payload.searchByInput ? payload.requests : state.get('matchedRequestsByInput'),
        searchingRequests: false,
        showRequests: Boolean(payload && payload.length),
      }));
    case 'GOT_LATEST_CONTRACTING_YEAR':
      return state.set('startDateValue', payload.startDate).set('endDateValue', payload.endDate);
    case constants.CREATING_CONTRACT:
      return state.set('creatingContract', true);
    case constants.CREATE_CONTRACT_FAILED:
      return state.set('creatingContract', false);
    case constants.CONTRACT_CREATED:
      return state.set('createdContract', fromJS(payload));
    case `${constants.GET_PARTNERS}_SUCCESS`:
      return state.set('partners', fromJS(payload.partners));
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/reducers/action-dialog-reducer.js